// Role for shop page
export const ROLE_TYPE = {
  ADMIN: 1,
  MERCHANT: 2,
  KOL: 4,
}
